import { operatorClient } from 'domain/HttpClients';

export const save = (data) => operatorClient
  .Post('/api/pricing/discounts')
  .withData(data)
  .send();
